import jQuery from 'jquery';
import 'slick-carousel';

;(function($){

function init(){

// Accordion
$('.c-accordion-term').append('<span/>');
$('.c-accordion-term.open').next().stop().slideDown();
$('.c-accordion-term').on('click', function(){
  $(this).toggleClass('open').next().stop().slideToggle();
});

// Tab
$('.c-tabs-list').on('click', function(){
  $(this).parent().children().not($(this)).removeClass('c-tabs-list-on');
  $(this).addClass('c-tabs-list-on');
  $(this).parent().next().children().removeClass('c-tabs-body-panel-on');
  const tabsIndex = $(this).index();
  $('.c-tabs-body-panel').eq(tabsIndex).addClass('c-tabs-body-panel-on')
});

// slider
$('.c-slider').each(function(){
  const $pageSlider = $('.c-slider-container',this);
  $pageSlider.slick({
    slidesToShow:3,
    slidesToScroll:1,
    pauseOnHover:false,
    pauseOnFocus:false,
    draggable:true,
    autoplay:true,
    autoplaySpeed:5000,
    dots:true,
    arrows:true,
    fade:false,
    appendDots:$('.c-slider-navi', this),
    dotsClass:'c-slider-dots',
    responsive: [
      {
        breakpoint:814,
        settings: {
          slidesToShow:1,
          centerMode: true,
          pauseOnHover:false,
          pauseOnFocus:false,
          draggable:false
        }
      }
    ]
  });

  // $pageSlider.append('<div class="c-slider-btnArea"><button class="c-slider-btnArea-tglBtn"><span class="c-slider-btnArea-startBtn">start</span><span class="c-slider-btnArea-stopBtn">stop</span></button></div>');
  $('.c-slider-btnArea-startBtn').hide();
  let flg = 'play';
  $('.c-slider-dots button',this).on('click', function(){
    $pageSlider.slick('slickPlay');
    $('.c-slider-btnArea-startBtn').hide();
    $('.c-slider-btnArea-stopBtn').show();
    flg = 'play';
    $('.c-slider-dots li',this).removeClass('stop-active');
  });
  $('.c-slider-btnArea-tglBtn',this).on('click', function(){
    if(flg == 'play') {
      $('.c-slider-btnArea-startBtn',this).show();
      $('.c-slider-btnArea-stopBtn',this).hide();
      flg = "stop";
      $pageSlider.slick('slickPause');
      $('.c-slider-dots .slick-active',this).addClass('stop-active');
    } else {
      $('.c-slider-btnArea-startBtn',this).hide();
      $('.c-slider-btnArea-stopBtn',this).show();
      flg = 'play';
      $pageSlider.slick('slickPlay');
      $pageSlider.slick('slickNext');
      $('.c-slider-dots li',this).removeClass('stop-active');
    }
  });
});
}
$(function(){
  init();
});

}(jQuery));